/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `VC` - Very Clean
* `CL` - Clean
* `DI` - Dirty
 */
export type DirtLevelEnum = typeof DirtLevelEnum[keyof typeof DirtLevelEnum];


export const DirtLevelEnum = {
  VC: 'VC',
  CL: 'CL',
  DI: 'DI',
} as const;
